import { getApiErrorInfo } from '@common/utils/fetcher';

import {
  ACCOUNT_ERROR_CODES,
  type AccountFeature,
} from '@services/AccountService';

import { useAccountStore } from './useAccountStore';

/**
 * Turns `feature` off in the account store when `error` is a 404
 * `feature_disabled`, and says whether it did; any other error is left to
 * the caller.
 *
 * Not for the invite routes (POST /matchmaker/invites/open and
 * /matchmaker/invites/candidate): there a `feature_disabled` means the
 * invite's matchmaker no longer passes the gate, not the invitee, so the
 * invitee's own features must stay as they are.
 */
export const disableFeatureOnError = (
  error: unknown,
  feature: AccountFeature,
) => {
  const { status, code } = getApiErrorInfo(error);

  if (status !== 404 || code !== ACCOUNT_ERROR_CODES.featureDisabled) {
    return false;
  }

  useAccountStore.getState().disableFeature(feature);

  return true;
};
